/**
 * Stats — 3 variants (row_4, cards_with_context, headline_pairing)
 */
import type { StatsContent } from '../schemas/stats';
import { Body, H2, SectionFrame } from './primitives';

interface SP {
  content: StatsContent;
}

export function StatsRow4({ content }: SP) {
  return (
    <SectionFrame>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 48 }}>
        {content.headline && <H2 className="ls-stats-headline">{content.headline}</H2>}
        <div className="ls-grid ls-grid-4">
          {content.stats.map((s, i) => (
            <div key={i} style={{ textAlign: 'left' }}>
              <div
                style={{
                  fontFamily: 'var(--ls-font-heading)',
                  fontSize: 'clamp(2rem, 4vw, 3.5rem)',
                  fontWeight: 700,
                  letterSpacing: '-0.02em',
                  color: 'var(--ls-accent)',
                  marginBottom: 8,
                }}
              >
                {s.value}
              </div>
              <Body style={{ fontWeight: 500, color: 'var(--ls-text)' }}>
                {s.label}
              </Body>
              {s.context && (
                <Body style={{ fontSize: '0.85rem', marginTop: 4 }}>
                  {s.context}
                </Body>
              )}
            </div>
          ))}
        </div>
      </div>
    </SectionFrame>
  );
}

export function StatsCardsWithContext({ content }: SP) {
  return (
    <SectionFrame background="surface">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 48 }}>
        {content.headline && <H2>{content.headline}</H2>}
        <div className="ls-grid ls-grid-3">
          {content.stats.map((s, i) => (
            <div key={i} className="ls-card" style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div
                style={{
                  fontFamily: 'var(--ls-font-heading)',
                  fontSize: '3rem',
                  fontWeight: 700,
                  color: 'var(--ls-accent)',
                  letterSpacing: '-0.02em',
                }}
              >
                {s.value}
              </div>
              <div style={{ fontSize: '1rem', fontWeight: 500 }}>{s.label}</div>
              {s.context && <Body style={{ fontSize: '0.85rem' }}>{s.context}</Body>}
            </div>
          ))}
        </div>
      </div>
    </SectionFrame>
  );
}

export function StatsHeadlinePairing({ content }: SP) {
  return (
    <SectionFrame>
      <div className="ls-split-pair" style={{ gap: 64 }}>
        <div>
          {content.headline && <H2>{content.headline}</H2>}
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 32 }}>
          {content.stats.map((s, i) => (
            <div key={i}>
              <div
                style={{
                  fontFamily: 'var(--ls-font-heading)',
                  fontSize: '2.25rem',
                  fontWeight: 700,
                  color: 'var(--ls-accent)',
                }}
              >
                {s.value}
              </div>
              <Body style={{ fontWeight: 500, color: 'var(--ls-text)' }}>
                {s.label}
              </Body>
              {s.context && <Body style={{ fontSize: '0.85rem', marginTop: 4 }}>{s.context}</Body>}
            </div>
          ))}
        </div>
      </div>
    </SectionFrame>
  );
}

export const statsVariants = {
  row_4: StatsRow4,
  cards_with_context: StatsCardsWithContext,
  headline_pairing: StatsHeadlinePairing,
};
